import { useDomainMessages } from 'domains/products/utils/domain/intl'

export enum SearchTypes {
  Name = 'name',
  RRC = 'rrc',
  UPC = 'upc',
  ProductId = 'productId',
}

export enum SearchError {
  TooManySearchTerms = 'Too many search terms',
  InvalidProductId = 'Invalid product id',
}

export const useSearchHints = (): Record<SearchTypes, string> => {
  const i18n = useDomainMessages({
    searchTypeNameHint: 'productsDomain.search.hints.name',
  })

  return {
    [SearchTypes.Name]: i18n.searchTypeNameHint,
    [SearchTypes.RRC]: '00091993, 150124, 120450...',
    [SearchTypes.UPC]: '00039978021540, 00039978009524...',
    [SearchTypes.ProductId]: '19551707',
  }
}
